module.exports = __webpack_public_path__ + "img/transactions.6213a26c.svg";